import { RouteObject } from "react-router-dom";

export const carrierRateRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Carrier rates" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { CarrierRatesPage } = await import("./carrier-rates-page");
          return { Component: CarrierRatesPage };
        },
      },
    ],
  },
];
